import React from "react";
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import { StateMachineProvider, createStore } from "little-state-machine";
import FormInput from "./component/FormInput";
import FormConfirm from "./component/FormConfirm";
import FormComplete from "./component/FormComplete";
import "./component/App.css";

createStore({});

function App() {
  return (
    <>
      <StateMachineProvider>
        <Router>
          <Route exact path="/entry">
            <FormInput />
          </Route>
          <Route exact path="/entry/confirm">
            <FormConfirm />
          </Route>
          <Route path="/entry/complete" exact>
            <FormComplete />
          </Route>
          <Redirect to="/entry" />
        </Router>
      </StateMachineProvider>
    </>
  );
}

export default App;
